import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EMAIL_UNSUBSCRIBE_REASONS } from 'src/app/shared/global/constants';
import { AuthService } from 'src/app/shared/services/auth-service/auth.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-unsubscribe-email',
  templateUrl: './unsubscribe-email.component.html',
  styleUrls: ['./unsubscribe-email.component.scss']
})
export class UnsubscribeEmailComponent implements OnInit {
  selectedValue:any = EMAIL_UNSUBSCRIBE_REASONS.EMAIL_RELEVANT
  paramsRes:any;
  reasonString:any;
  emailsReason:any = [EMAIL_UNSUBSCRIBE_REASONS.EMAIL_RELEVANT ,EMAIL_UNSUBSCRIBE_REASONS.EMAIL_FREQUENT,EMAIL_UNSUBSCRIBE_REASONS.REMEBER_SIGNING,EMAIL_UNSUBSCRIBE_REASONS.SPAM,EMAIL_UNSUBSCRIBE_REASONS.OTHER ]
  constructor(
    public authService:AuthService,
    private activatedRoute: ActivatedRoute,
    private ToastrServices: ToastrService,
    private router: Router,
    private translate: TranslateService,
  ) { 
    this.translate.setDefaultLang('en');
    this.activatedRoute.queryParams.subscribe(async (params) => {
      this.paramsRes = params;
  })
  }

  ngOnInit(): void {
    this.selectedValue = EMAIL_UNSUBSCRIBE_REASONS.EMAIL_RELEVANT
    
  }


  async submit(){
    (await this.authService.unsubscribeMail(parseInt(this.paramsRes?.company_id),parseInt(this.paramsRes?.user_id),this.selectedValue,this.reasonString)).subscribe((res) => {
     if(res?.data?.is_unsubscribed){
      this.ToastrServices.success('Successfuly unsubscribed daily email');
      this.router.navigate(["/dashboard"])
     } 
    });
  }
}


